<template>
  <div id="home">
    <el-container>
      <el-aside :class="isCollapse?'aside-collapse-width':'aside-width'">
        <el-menu
          router
          class="el-menu-vertical-demo"
          :default-active="defaultActive"
          :collapse="isCollapse"
          :collapse-transition = "false"
        >
          <div style="height: 70px" :class="[ 'home-logo',isCollapse ? '' : 'big-logo']">
            <!-- <img src="~assets/img/logo.png" alt="" srcset="" > -->
            <div class="tit">AIFENIX</div>
          </div>
          <el-menu-item :index="'dashboard'" key="dashboard">
            <i class="el-icon-s-home"></i>
            <span slot="title">Dashboard</span>
          </el-menu-item>
          <el-menu-item :index="'vehicle'" key="vehicle">
            <i class="el-icon-third-Truck"></i>
            <span slot="title">Vehicle</span>
          </el-menu-item>
          <el-menu-item :index="'trailer'" key="trailer">
            <i class="el-icon-third-trailer" style="font-size: 14px;"></i>
            <span slot="title">Trailer</span>
          </el-menu-item>
          <el-menu-item :index="'gateway'" key="gateway">
            <i class="el-icon-third-ggateway" style="font-size: 22px;"></i>
            <span slot="title">Gateway</span>
          </el-menu-item>
          <el-menu-item :index="'sensor'" key="sensor">
            <i class="el-icon-third-sensor"></i>
            <span slot="title">Sensor</span>
          </el-menu-item>
          <el-menu-item :index="'alert'" key="alert">
            <i class="el-icon-warning-outline"></i>
            <span slot="title">Alert</span>
          </el-menu-item>
          <el-menu-item :index="'user'" key="user">
            <i class="el-icon-user"></i>
            <span slot="title">User</span>
          </el-menu-item>
          <el-menu-item :index="'setting'" key="setting">
            <i class="el-icon-setting"></i>
            <span slot="title">Setting</span>
          </el-menu-item>
        </el-menu>
       
      </el-aside>
      <el-container>
        <el-header>
          <hamburger id="hamburger-container" :is-active="isCollapse" class="hamburger-container" @toggleClick="toggleSideBar" />
          <el-dropdown class="username">
            <span >
              <el-avatar :size="50">{{username}}</el-avatar>
            </span>
            
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item >
                <span @click="handleDialog" style="display: block;">Change Password</span>
              </el-dropdown-item>
              <el-dropdown-item >
                <span @click="handleLogout" style="display: block;">Logout</span>
              </el-dropdown-item>
              
            </el-dropdown-menu>
          </el-dropdown>

        </el-header>
        <el-main>
            <router-view />
        </el-main>
        <el-footer>
          T.I.M ©2023 Powered by Nextan
        </el-footer>
      </el-container>
      <el-dialog :visible.sync="dialogFormVisible" width="600px">
        <el-form ref="changePwdForm" :rules="rules" :model="temp" label-position="left" label-width="150px">
          <el-form-item label="Current Password" prop="currentPassword">
            <el-input 
              type="password"
              show-password
              v-model="temp.currentPassword" />
          </el-form-item>
          <el-form-item label="New Password" prop="newPassword">
            <el-input 
              type="password"
              show-password
              v-model="temp.newPassword" />
          </el-form-item>
          <el-form-item label="Confirm Password" prop="confirmPassword">
            <el-input 
              type="password"
              show-password
              v-model="temp.confirmPassword" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('changePwdForm')">
            Submit
          </el-button>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import { logout } from "network/login"
import { changePassword } from "network/password"
import { removeToken } from "common/auth"
import Hamburger from "components/hamburger"

export default {
  name: "Home",
  components: {
    Hamburger
  },
  data() {
    const validateNewPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the new password'));
      } else {
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.temp.newPassword) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };
    return {
      isCollapse: true,
      username: sessionStorage.getItem("username") ? sessionStorage.getItem("username")[0].toUpperCase() : "",
       temp: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {
        currentPassword: [{ required: true, message: 'Please input current password.', trigger: 'blur' }],
        newPassword: [{ required: true, validator: validateNewPwd, trigger: 'blur' }],
        confirmPassword: [{ required: true,validator: validateConfirmPwd, trigger: 'blur' }],
      },
    };
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
    },
    handleDialog () {
      this.dialogFormVisible= true
      this.$nextTick(() => {
        this.$refs['changePwdForm'].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const subData = {
            password: this.temp.currentPassword,
            new_password: this.temp.newPassword,
            confirm_password: this.temp.confirmPassword
          }

          changePassword(subData)
            .then( data => {
              if (data.status === 202) {
                this.$message({
                  message: "Updated Successfully.",
                  type: "success",
                });
                this.$refs['changePwdForm'].resetFields()
                this.dialogFormVisible= false
              } else {
                this.$message.error("Please enter the correct current password.");
              }
            }).catch(err => {
              this.$message.error("Please enter the correct current password.");
            })
        } 
      })
    },
    handleLogout() {
      const refresh = sessionStorage.getItem("refresh")
      const submitData = {
        refresh: refresh
      }
      logout(submitData)
        .then(data => {
          console.log(data);
          if (data.status === 200) {
            removeToken()
            window.location.reload()
          }
        })
    }
  },
  created() {},
  computed: {
    defaultActive: function(){
      return this.$route.path.replace('/', '');
    }
  },
};
</script>

<style scoped>
  .el-container {
    min-height: 100vh;
  }
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  .home-logo {
    text-align: center;
    line-height: 70px;
  }
  .home-logo img {
    margin-top: 16px;
    width: 50px;
  }
  .home-logo .tit{
    font-size: 14px;
    color: #fff;
  }
  .home-logo.big-logo img{
    margin-top: 0px !important;
    width: 100px;
  }
  .home-logo.big-logo .tit{
    font-size: 24px;
    letter-spacing: 1px;
  }
  .aside-width {
    width: 200px !important;
  }
  .el-menu{
    border-right: 0;
  }
  .el-menu-item {
    color: #fff;
  }
  .el-menu-item.is-active {
    color: #409EFF;
  }
  .aside-collapse-width{
    width: 64px !important;
  }
  .el-menu-vertical-demo {
    height: 100%;
    background-color: #37474f;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    height: 100%;
  }
  .username {
    float: right;
    margin-top: 10px;
    margin-right: 60px;
    line-height: 20px;
    cursor: pointer;
  }
  .username .el-avatar {
    font-size: 30px;
    background-color: #37474f;
  }
  .home-noti {
    float: right;
    position: relative;
  }
  .home-noti i {
    font-size: 46px;
    margin-top: 12px;
    margin-right: 30px;
    color: #686868;
  }
  .home-noti .num {
    position: absolute;
    top: 12px;
    right: 28px;
    width: 20px;
    height: 20px;
    background: red;
    border-radius: 50%;
    line-height: 20px;
    color: #fff;
    text-align: center;
  }
  .el-header {
    background: #ecebeb;
    height: 70px !important;
  }
  .el-footer{
    height: 40px !important;
    line-height: 40px !important;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    background: #f0f2f5;
  }
  .hamburger-container {
    line-height: 70px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: #fff .3s;
    -webkit-tap-highlight-color:transparent;
   }
  .hamburger-container:hover {
    background: rgba(0, 0, 0, .025)  
  }
</style>